import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-15" data-mp="bq9eoonxl5zp">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" data-id="element-16" data-mp="195wtrgmi5xbj">
          <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md animate-shake items-center justify-between gap-3 rounded-2xl bg-flame px-5 py-3.5 text-white shadow-[0_6px_0_0_#B8330A,0_18px_40px_-8px_rgba(0,0,0,0.55)] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/60" data-id="element-17" data-mp="2f40yg72i4po2">
            <span className="flex flex-col leading-tight" data-id="element-18" data-mp="1rdet4njvtjhr">
              <span className="font-display text-xl font-extrabold uppercase tracking-wide" data-id="element-19" data-mp="1wdjdionwuyd9">Get the Blueprint · $27</span>
              <span className="text-xs font-medium text-white/90" data-id="element-20" data-mp="1ieb7pcx8ss03">6 volumes + 5 bonuses · Instant access</span>
            </span>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-flame" data-id="element-21" data-mp="1ndnwi37oc95b">
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-22" data-mp="3cskj1ol06iau" />
            </span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}